/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Execution_Type_Reps_RangeInputs */

const fr_execution_type_reps_range = /** @type {(inputs: Execution_Type_Reps_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Répétitions (plage)`)
};

/**

* @param {Execution_Type_Reps_RangeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const execution_type_reps_range = /** @type {((inputs?: Execution_Type_Reps_RangeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Execution_Type_Reps_RangeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_execution_type_reps_range(inputs)
});